(function(){
var slides=document.querySelectorAll('.ep-gallery-slide'),thumbs=document.querySelectorAll('.ep-thumb');
function setSlide(i){if(i<0)i=slides.length-1;if(i>=slides.length)i=0;
slides.forEach(function(s,x){s.classList.toggle('active',x===i);});
thumbs.forEach(function(t,x){t.classList.toggle('active',x===i);});}
function cur(){var a=document.querySelector('.ep-gallery-slide.active');return a?parseInt(a.dataset.index):0;}
thumbs.forEach(function(t){t.addEventListener('click',function(){setSlide(parseInt(this.dataset.index));});});
var p=document.querySelector('.ep-gallery-prev'),n=document.querySelector('.ep-gallery-next');
if(p)p.addEventListener('click',function(){setSlide(cur()-1);});
if(n)n.addEventListener('click',function(){setSlide(cur()+1);});
var box=document.querySelector('.ep-gallery-main');
if(box){var sx=0;
box.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
box.addEventListener('touchend',function(e){var d=sx-e.changedTouches[0].clientX;
if(Math.abs(d)<40)return;setSlide(d>0?cur()+1:cur()-1);},{passive:true});}
var q=document.getElementById('ep-qty');
var mi=document.getElementById('ep-minus'),pl=document.getElementById('ep-plus');
if(mi)mi.addEventListener('click',function(){if(q&&q.value>1)q.value=parseInt(q.value)-1;});
if(pl)pl.addEventListener('click',function(){if(q)q.value=parseInt(q.value)+1;});
document.querySelectorAll('.epa-head').forEach(function(h){
h.addEventListener('click',function(){this.parentNode.classList.toggle('is-open');});});
var VARIANTS=window.EP_VARIANTS||[];
document.querySelectorAll('.ep-opt-btn').forEach(function(b){
b.addEventListener('click',function(){
var pos=this.dataset.optionPosition;
document.querySelectorAll('.ep-opt-btn[data-option-position="'+pos+'"]').forEach(function(o){o.classList.remove('active');});
this.classList.add('active');
var sel={};
document.querySelectorAll('.ep-opt-btn.active').forEach(function(o){sel[parseInt(o.dataset.optionPosition)-1]=o.dataset.value;});
var m=VARIANTS.find(function(v){return Object.keys(sel).every(function(i){return v['option'+(parseInt(i)+1)]===sel[i];});});
if(!m)return;
document.getElementById('ep-variant-id').value=m.id;
var pe=document.querySelector('.ep-price');
if(pe)pe.textContent=(m.price/100).toLocaleString('ro-RO',{minimumFractionDigits:2,maximumFractionDigits:2})+' lei';
var ab=document.getElementById('ep-atc-btn'),at=document.getElementById('ep-atc-text');
if(ab&&at){ab.disabled=!m.available;at.textContent=m.available?'Adauga in cos':'Stoc epuizat';}
});});
var f=document.getElementById('ep-form');
if(f)f.addEventListener('submit',function(e){
e.preventDefault();e.stopPropagation();
var b=document.getElementById('ep-atc-btn'),t=document.getElementById('ep-atc-text');
if(!b||b.disabled)return;
var old=t.textContent;t.textContent='Se adauga...';b.disabled=true;
fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
body:JSON.stringify({id:parseInt(document.getElementById('ep-variant-id').value),quantity:parseInt(q?q.value:1)})})
.then(function(r){return r.json();})
.then(function(){t.textContent='Adaugat in cos';
if(typeof window.erOpenCart==='function')window.erOpenCart();
setTimeout(function(){t.textContent=old;b.disabled=false;},2200);})
.catch(function(){t.textContent=old;b.disabled=false;});});
var st=document.getElementById('ep-sticky');
if(st&&f&&'IntersectionObserver' in window){
new IntersectionObserver(function(en){
st.style.display=(window.matchMedia('(max-width:900px)').matches&&!en[0].isIntersecting)?'flex':'none';
},{threshold:0.1}).observe(f);}
})();